module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/bg_pattern-ab73af4af5ed9fd0d6b4f29f71f2f6c7.png";